import * as React from 'react';
// Import props.
import {
	ComparativePublicBuildingsSummaryProps,
	ComparativePublicBuildingSummaryProps,
    ComparativeDataHeaderProps,
} from '@app/props';
// Import mui components.
import {
	CorporateFare,
} from '@mui/icons-material';

interface UseComparativePublicBuildingsSummaryParameters {
	props: ComparativePublicBuildingsSummaryProps;
}
interface UseComparativePublicBuildingsSummaryResults {
	buildingBaseId: string;
	applyComparativePublicBuildingSummaryPropsList: () => ComparativePublicBuildingSummaryProps[];
	applyComparativePublicBuildingsSummaryHeaderProps: () => ComparativeDataHeaderProps;
}

const useComparativePublicBuildingsSummary = (params: UseComparativePublicBuildingsSummaryParameters): UseComparativePublicBuildingsSummaryResults => {

	// #region exported methods

	const applyComparativePublicBuildingSummaryPropsList = (): ComparativePublicBuildingSummaryProps[] => {
		return params.props.buildings.map((building, index: number) => {
			return {
				id: `${buildingBaseId}-building-${building.id}`,
				building,
				title: generateBuildingTitle(building.buildingData?.buildingDescription ?? undefined, index),
				areHeadersSticky,
			}
		});
	}

	const applyComparativePublicBuildingsSummaryHeaderProps = (): ComparativeDataHeaderProps => {
		return {
			id: `${buildingBaseId}-header`,
			isSticky: areHeadersSticky,
			title: 'Buildings',
			titleIcon: CorporateFare,
			titleFontSize: 'md',
			spacingBetweenIconAndTitle: 1,
			paddingProps: {
				bottom: 0,
				top: 1,
			}
		};
	}

	// #endregion exported methods


	// #region private methods

	const generateBuildingTitle = (title: string | undefined, index: number): string => {
		return String.isNullOrWhiteSpace(title)
			? `Building #${index + 1}`
			: `${title}`;
	}

	// #endregion private methods

	// #region variables

	const areHeadersSticky: boolean = React.useMemo(() => {
		return params.props.areHeadersSticky ?? false;
	}, [params.props.areHeadersSticky]);

	const buildingBaseId: string = React.useMemo(() => {
		return `${params.props.id}-buildings`;
	}, [params.props.id]);

	// #endregion private variables

	// #region life-cycle methods

	// #endregion life-cycle methods.

	return {
		buildingBaseId,
		applyComparativePublicBuildingSummaryPropsList,
		applyComparativePublicBuildingsSummaryHeaderProps,
	};
}

// Export parameters.
export {
	UseComparativePublicBuildingsSummaryParameters,
}

// Export results.
export {
	UseComparativePublicBuildingsSummaryResults,
}

export default useComparativePublicBuildingsSummary;